<!-- eslint-disable max-len -->
<!-- eslint-disable max-lines -->
<template>
    <div class="policy-protocol-page">
        <div class="policy-child-doc">
            <h1 class="policy-child-doc__title">
                毛豆应用产品-用户服务协议
            </h1>
            <p class="policy-child-doc__meta">
                生效时间：2020年8月24<br>更新时间：2026年5月7日
            </p>
            <p class="policy-child-doc__intro">
                欢迎访问毛豆应用产品！高途教育科技集团有限公司-毛豆学部-毛豆项目组（下称高途毛豆）负责毛豆系列手机应用软件的运营、管理。
            </p>
            <p class="policy-child-doc__p">
                本协议由您与高途毛豆共同缔结，本协议具有合同效力。
            </p>
            <p class="policy-child-doc__p">
                本协议中协议双方合称协议方。
            </p>
            <p class="policy-child-doc__p">
                本协议内容包括协议正文及所有高途毛豆已经发布的或将来可能发布的各类规则，所有规则为本协议不可分割的组成部分，与协议正文具有同等法律效力。
            </p>
            <p class="policy-child-doc__p">
                本协议阐述之条款和条件适用于毛豆系列手机应用软件的全部学习服务，包括但不限于各种学习内容、资料及相应服务。
            </p>
            <p class="policy-child-doc__p">
                您应当在使用毛豆系列应用软件服务之前认真阅读全部协议内容（未成年人应在法定监护人陪同下阅读）。如对协议有任何疑问，应向高途毛豆咨询，咨询邮箱：xuelu@gaotu.cn
            </p>
            <p class="policy-child-doc__p">
                但无论您事实上是否在使用毛豆系列应用软件服务之前认真阅读了本协议内容，只要使用毛豆系列应用软件及相关服务，则本协议即对您产生约束，届时您不应以未阅读本协议的内容或者未获得高途毛豆对您问询的解答等理由，主张本协议无效，或要求撤销本协议。您承诺接受并遵守本协议的约定。如果您不同意本协议的约定，应立即停止注册程序或停止使用毛豆系列应用软件服务。
            </p>
            <p class="policy-child-doc__p">
                高途毛豆应用团队有权根据相关法律法规的变更或业务变化等不时地制订、修改本协议及/或各类规则，并将调整后的协议公布于高途毛豆官网、公众号、社群或者毛豆系列应用软件中。如您不同意相关变更，应当立即停止使用毛豆系列应用软件服务。若您继续使用毛豆系列应用软件服务，即表示您接受经修订的协议。
            </p>
            <section class="policy-child-doc__section">
                <h2>一、服务协议</h2>
                <p class="policy-child-doc__p">
                    1、用户充分了解并同意：用户必须为自己注册账号下的一切行为负责，包括用户所传送的任何内容以及由此产生的任何结果。
                </p>
                <p class="policy-child-doc__p">
                    2、产品中高途毛豆的原创内容，版权完全归高途毛豆所有，用户不得拷贝他用，不得上传到其它网络平台。高途毛豆保留对此种非法行为进行追究的权利。
                </p>
                <p class="policy-child-doc__p">
                    3、用户不得利用毛豆系列应用软件进行违反国家法律法规、侵犯他人权益的行为。高途毛豆可依其合理判断，对违反有关法律法规或本协议约定的用户进行处理，并且依据法律法规保存有关信息并向有关部门报告。
                </p>
            </section>
            <section class="policy-child-doc__section">
                <h2>二、毛豆系列应用软件使用规则</h2>
                <p class="policy-child-doc__p">
                    1、用户注册
                </p>
                <p class="policy-child-doc__p">
                    为了完整使用高途毛豆提供的服务，用户需要注册一个毛豆系列应用软件的账户。账户名为用户所提供的常用手机号码，用户需通过毛豆系列应用软件下发的验证码进行账户验证后，该账户即完成初步注册。在个人中心里，用户可设置相关个人信息。用户可以在账户中查询到自己的购买/兑换记录和资金等情况。
                </p>
                <p class="policy-child-doc__p">
                    2、账户管理
                </p>
                <p class="policy-child-doc__p">
                    用户使用高途毛豆服务，应负责维护自己账户的保密性并限制第三方使用/访问其移动设备，用户对其账户和验证码下发生的所有活动承担法律责任。
                </p>
                <p class="policy-child-doc__p">
                    3、订单及支付
                </p>
                <p class="policy-child-doc__p">
                    本条款所述“订单”，是指用户根据自身需求与高途毛豆达成的学习产品使用服务协议。订单在下述条件同时满足时正式成立：
                </p>
                <p class="policy-child-doc__p">
                    1） 用户在毛豆系列应用软件服务中找到符合自己需求的学习内容；
                </p>
                <p class="policy-child-doc__p">
                    2） 用户已向高途毛豆支付订单费用；
                </p>
                <p class="policy-child-doc__p">
                    在您下单时，请您仔细确认所开通会员的名称、价格、联系地址、电话、收货人、商品类型等信息。收货人与用户本人不一致的，收货人的行为和意思表示视为用户的行为和意思表示，用户应对收货人的行为及意思表示的法律后果承担连带责任。
                </p>
                <p class="policy-child-doc__p">
                    4、学习形式
                </p>
                <p class="policy-child-doc__p">
                    1）毛豆系列应用软件的学习方式主要为视频动画、儿歌与游戏互动等方式，用户可在会员有效期内随时使用产品内的功能和内容，所产生的流量费用、上网费用由用户自行承担。
                </p>
                <p class="policy-child-doc__p">
                    2）用户同意高途毛豆因产品升级优化等需要变更产品内容及功能等。
                </p>
                <p class="policy-child-doc__p">
                    5、退款
                </p>
                <p class="policy-child-doc__p">
                    1）我们特别提醒您，由于我们提供的部分付费服务属于数字化商品，根据相关法规不属于法定七日无理由退货范围，请您付款前仔细阅读各毛豆系列应用软件内的付费权益详情介绍、核对并确认需要充值/付费的毛豆系列应用软件账号、具体付费服务内容及金额，一旦您支付成功，除非法律规定、本协议和/或特定协议和/或特定产品具体规则另有约定，您所购买的数字化商品不能够进行退货、换货、兑换现金、转让，亦不得用于商业领域，如买卖、置换、抵押等。若您因误操作等原因需要我们帮助的，请通过咨询邮箱：xuelu@gaotu.cn或产品首页客服中心与我们联系。请您理解，前述帮助义务不应超过我们的合理承受限度。需要提醒您的是，在处理过程中，我们的客服可能需要您提供您真实有效的用户身份证明材料（包括但不限于毛豆系列应用软件账户中心已登录页面截图）后方可为您进行处理。若您因付费问题与其他毛豆系列应用软件用户发生争议的，您还可以通过自行协商、诉讼等方式解决。
                </p>
                <p class="policy-child-doc__p">
                    我们有权决定毛豆系列应用软件产品与/或服务的资费标准。我们可能会因毛豆系列应用软件产品与/或服务的产品类型、权益范围和权益期限的不同，制定不同的资费标准，详细约定以各款毛豆系列应用产品公布、实际展示的资费标准为准。
                </p>
                <p class="policy-child-doc__p">
                    2）您理解并同意，您付费购买的毛豆系列应用产品与/或服务的具体权益内容以您购买时为准。随着毛豆系列应用产品与/或服务的不时更新，毛豆系列应用产品与/或服务的具体内容可能会有所更改或扩充，您需要付费购买更改或扩充后的部分，资费标准以毛豆系列应用产品公布、实际展示的为准。如您不同意付费购买更改或扩充后的部分，则无法使用相应的毛豆系列应用软件与/或服务。如您需要咨询相关问题，请通过咨询邮箱：xuelu@gaotu.cn或产品首页客服中心与我们联系。
                </p>
                <p class="policy-child-doc__p">
                    我们善意提醒您，由于不同App应用商店的政策以及我们的营销策略不同，我们的不同款毛豆系列应用软件与/或服务在不同应用商店的实际标价有可能不同，同一款毛豆系列应用软件与/或服务在不同的应用商店展示的价格亦有可能不同，我们亦可能仅在特定的应用商店上架销售仅供该应用商店用户购买的毛豆系列应用软件与/或服务。结算价格应以通过特定应用商店账号登录时，其所属区域公布的价格为准。
                </p>
                <p class="policy-child-doc__p">
                    3）您理解并同意，您支付前述服务费用的方式包括通过我们接入的第三方支付工具（如微信支付、支付宝等）向我们进行付款，当然您也可以向App Store、华为应用商店等第三方应用商店进行充值以完成您的支付。如支付工具有更新，我们会在支付页面上及时更新支付规则并通知您，详细约定以毛豆系列应用软件公布、实际展示的支付规则为准。
                </p>
                <p class="policy-child-doc__p">
                    4）此外，需要特别提示您，根据App Store、华为应用商店的政策，其可能会向您提供自动扣费服务，请您在选择使用前仔细阅读App Store、华为应用商店的相关政策。若您希望取消自动扣费功能的，请您根据App Store、华为应用商店的相关政策及退订规则操作或与苹果公司、华为公司取得联系。另外用户通过苹果IOS系统充值虚拟币开通会员的，不支持退款，需要联系App Store官方相关人员自行处理。
                </p>
                <p class="policy-child-doc__p">
                    6、账户注销
                </p>
                <p class="policy-child-doc__p">
                    高途毛豆为您提供注销毛豆系列应用软件账号的权利。您可以联系我们的客服注销您的毛豆系列应用软件账号（法律法规另有规定的或本协议另有约定的除外）。请您注意，注销账号是不可逆的行为，一旦您注销账号：
                </p>
                <p class="policy-child-doc__p">
                    （1）您将无法登录、使用毛豆系列应用软件账号以及高途毛豆提供的毛豆系列应用软件与/或服务；
                </p>
                <p class="policy-child-doc__p">
                    （2）视为您自动放弃已有的权益（包括但不限于放弃已购买的不限使用时限的付费内容的使用权限）。我们无法帮您找回您毛豆系列应用软件账号中与账号相关的任何内容或信息，如您毛豆系列应用软件账号的个人资料和历史信息（包括但不限于昵称、头像等）。
                </p>
                <p class="policy-child-doc__p">
                    （3）即使您注销账号后再次使用原注册/登录方式注册新的毛豆系列应用软件账号，仍会被视为新的毛豆系列应用软件注册账号，您亦不能以曾经购买过相关权益为由而主张在不付费的情况下使用已注销账号内曾享有的权益。请您认真考虑并谨慎操作，并建议您在操作前自行备份与拟注销账号相关的所有信息和数据。
                </p>
                <p class="policy-child-doc__p">
                    经过谨慎考虑，如果您仍需要注销账号的，您在注销时您的毛豆系列应用软件账号需要同时满足以下条件：
                </p>
                <p class="policy-child-doc__p">
                    （1）您的毛豆系列应用软件账号无任何纠纷，包括投诉举报或被投诉举报；
                </p>
                <p class="policy-child-doc__p">
                    （2）您的毛豆系列应用软件账号为正常使用中的账号，且提交注销申请时，您的毛豆系列应用软件账号无任何被限制的记录；
                </p>
                <p class="policy-child-doc__p">
                    （3）您的毛豆系列应用软件账号务必解绑其他关联账号（如有）。
                </p>
                <p class="policy-child-doc__p">
                    从申请注销毛豆系列应用软件账号到最后注销成功这一期间，如果您的毛豆系列应用软件账号涉及争议或纠纷，包括但不限于投诉、举报、诉讼、仲裁、国家有权机关调查等，高途毛豆有权自行中止或终止您的毛豆系列应用软件账号注销流程，而无需另行获得您的同意。
                </p>
                <p class="policy-child-doc__p">
                    高途毛豆提示您注意，您申请注销毛豆系列应用软件账号并不代表您的毛豆系列应用软件账号在完成注销前，因您使用该账号所导致的相关责任会通过注销账号而豁免或减轻。
                </p>
            </section>
            <section class="policy-child-doc__section">
                <h2>三、用户权利及义务</h2>
                <p class="policy-child-doc__p">
                    1、用户须为合法目的使用高途毛豆提供的服务。
                </p>
                <p class="policy-child-doc__p">
                    2、用户一经注册或登录使用毛豆系列应用软件，即视为用户同意高途毛豆的客服人员与其进行电话联系。
                </p>
                <p class="policy-child-doc__p">
                    3、用户有权更改、删除在毛豆系列应用软件上的个人资料、注册信息及传送内容等，但需注意，删除有关信息的同时也会删除任何您储存在系统中的文字和图片。用户需承担该风险。
                </p>
                <p class="policy-child-doc__p">
                    4、用户账号仅供本人使用，用户有责任妥善保管注册账号信息及账号密码的安全，不得转让、出借、出租、出售或共享予他人使用，毛豆系列应用软件限制登录设备的数量，在注册毛豆系列应用软件账号后，为保证账号使用的安全性，同一个毛豆系列应用软件账号最多可以同时在三个设备上登录使用（“设备”指包括但不限于平板电脑、智能手机、智能大屏、智能音箱等终端设备，但不包括台式计算机、笔记本电脑、电视等）。超过上述范围使用或有明显异常登录情况的，我们将会根据情况采取中断或拒绝超出/异常部分设备的登录、中止或终止对您的服务等措施。造成的损失将由您自行承担，且我们保留采取进一步措施的权利，并禁止以任何形式倒卖、贩售、出租、出借、转让、共享用户账号、优惠券或折扣等其他优惠方式的行为，一经查明，高途毛豆将采取包括但不限于封号、封禁IP、追究相关责任人法律责任的处理措施。
                </p>
                <p class="policy-child-doc__p">
                    5、高途毛豆不时将对付费服务提供优惠政策或开展优惠活动，该等优惠政策或优惠活动以毛豆系列应用软件上的实时信息为准，用户知悉并认可，高途毛豆有权自行决定是否提供优惠政策或开展优惠活动，以及优惠政策或优惠活动的内容、条件和有效期，并不时进行调整或终止。
                </p>
                <p class="policy-child-doc__p">
                    6、毛豆系列应用软件内提供的服务分为免费服务和收费服务。对于现阶段免费提供的服务内容，高途毛豆有权随时根据公司政策的调整将其变更为收费服务，如果发生该等变更的，高途毛豆将提前告知用户，如果用户不同意的，可以停止使用该服务。对于收费的服务内容，高途毛豆有权自行确定该等服务的价格并不时调整，调整后的价格将在毛豆系列应用软件中进行公示，如果用户不同意调整后的价格的，则用户可以在其原购买的收费服务到期后停止付费购买收费服务。如果用户在高途毛豆调整价格并公示后，仍继续购买收费服务的，则视为用户同意该调整后的价格。
                </p>
                <p class="policy-child-doc__p">
                    7、用户开通会员后仅供购买用户本人学习，不得采取下载、录屏、出售、上传其他存储空间等任何方式提供给其他人。用户仅基于自我学习之目的享有使用毛豆系列应用软件服务的权利，未经高途毛豆书面许可，用户不得对毛豆系列应用软件及网站中包括但不限于音频、视频、文字、图片、软件等任何内容进行下载、录屏、复制、售卖等违反知识产权相关法律、法规的行为，由此所导致的一切民事、行政或刑事责任，由用户自行承担。
                </p>
                <p class="policy-child-doc__p">
                    8、高途毛豆有权随时对网站提供的服务内容等进行调整，包括但不限于增加、删除、修改毛豆系列应用软件服务内容，一旦毛豆系列应用软件的服务内容发生增加、删除、修改，高途毛豆将在相关页面上进行提示；如果用户不同意相关变更和修改，可以取消已经获取的服务并停止使用；如果用户继续使用高途毛豆提供的服务，则视为用户已经接受全部变更、修改。除非另有明确约定，否则用户使用毛豆系列应用软件内新增的服务内容将同样受本协议各项条款的约束。
                </p>
                <p class="policy-child-doc__p">
                    9、 奖励、金豆/熊猫币
                </p>
                <p class="policy-child-doc__p">
                    1）奖励是指部分毛豆系列应用软件根据您和/或您孩子对毛豆系列应用软件的使用程度，给予您和/或您孩子的增值兑换工具。不同毛豆系列应用软件对奖励功能有不同的名称（如熊猫币、金豆等）表述。您理解并同意，我们有权决定奖励与其他增值兑换工具的兑换规则（包括但不限于获得方式、使用规则、有效期、可兑换产品清单），详细约定以该毛豆系列应用软件公布、实际展示的奖励与兑换规则为准。
                </p>
                <p class="policy-child-doc__p">
                    2） 金豆是指毛豆系列应用软件内的购买工具，可用于购买或兑换毛豆系列应用软件内商城内的部分礼品（虚拟或实物），具体使用规则以毛豆系列应用软件内实际展示和说明的为准。
                </p>
                <p class="policy-child-doc__p">
                    3） 您理解并同意，奖励和金豆/熊猫币仅限于依据本协议以及各款毛豆系列应用软件内的使用规则进行消耗、使用。您和/或您孩子不得利用奖励和金豆/熊猫币从事除正常消耗以外的其它买卖、置换、抵押或其他商业行为。您和/或您孩子应通过正常流程取得金豆或熊猫币，一切通过非官方公布渠道或者以非正常手段取得的奖励和金豆/熊猫币均不具有法律效力。如有以上情形发生，我们有权不经通知单方面对您采取警告、限期改正、临时封禁、永久封禁账号、扣除或清零账号内奖励和金豆/熊猫币等措施，您应自行承担一切责任。
                </p>
                <p class="policy-child-doc__p">
                    10、我们提供的毛豆系列应用软件与/或服务中任何标注的“永久性”、“长期性”、“终身”等其他同等含义的描述性词汇，其使用期限不得被解释为永远不会停止，应被理解为其使用期限截止该等毛豆系列应用产品与/或服务停运之日；其使用范围不得被解释为毛豆系列应用软件与/或服务运营期间的所有的付费内容模块，应被理解为该等毛豆系列应用软件与/或服务在付费购买时所对应的内容模块范围。即使某项毛豆系列应用软件与/或服务标注有“永久性”、“长期性”、“终身”等其他同等含义的描述性词汇，我们有权对该项毛豆系列应用软件与/或服务之后新增的其他内容模块收取额外的费用，具体以届时各款毛豆系列应用软件公布、实际展示的资费标准为准。
                </p>
                <p class="policy-child-doc__p">
                    11、用户可以在毛豆系列应用软件的咨询邮件或首页客服中心向高途毛豆提出建议、意见或其他信息，但评价内容不得违反中国现行法律法规及其他规范性文件要求。用户不得恶意攻击、辱骂、诽谤、骚扰高途毛豆工作人员或毛豆系列应用软件的其他用户。用户不得在毛豆系列应用软件上发布任何虚假、违法信息及言论。用户上传毛豆系列应用软件的任何内容如涉嫌违法或侵犯第三方合法权利的，用户须独立承担因此所产生法律责任，包括但不限于对权利人的赔偿及对高途毛豆的赔偿。高途毛豆为任何涉嫌被侵权的权利人设置便捷的投诉渠道，并依法采取合理救济措施。投诉邮箱：xuelu@gaotu.cn。高途毛豆在收到投诉后将依据中国法律法规等及高途毛豆管理规定等采取措施进行处理，包括但不限于删除相关内容或屏蔽、断开相关链接，以及其他高途毛豆认为适当的处理方式，情节严重者，高途毛豆有权向政府相关部门进行举报。
                </p>
            </section>
            <section class="policy-child-doc__section">
                <h2>四、用户隐私保护条款</h2>
                <p class="policy-child-doc__p">
                    1、用户在毛豆系列应用软件注册账号或使用服务的过程中，可能需要填写或提交一些必要的信息，如法律法规、规章规范性文件规定的需要填写的身份信息。如用户提交的信息不完整或不符合法律法规的规定，则用户可能无法使用本服务或在使用本服务的过程中受到限制。
                </p>
                <p class="policy-child-doc__p">
                    2、个人隐私信息是指涉及用户个人身份或个人隐私的信息，比如，用户真实姓名、身份证号、手机号码、手机设备识别码、IP地址、用户聊天记录。非个人隐私信息是指用户对本服务的操作状态以及使用习惯等明确且客观反映在毛豆系列应用服务器端的基本记录信息、个人隐私信息范围外的其它普通信息，以及用户同意公开的上述隐私信息。
                </p>
                <p class="policy-child-doc__p">
                    3、尊重用户个人隐私信息的私有性是高途毛豆的一贯制度，高途毛豆将采取技术措施和其他必要措施，确保用户个人隐私信息安全，防止在毛豆系列应用服务中收集的用户个人隐私信息泄露、毁损或丢失。在发生前述情形或者高途毛豆发现存在发生前述情形的可能时，将及时采取补救措施。
                </p>
                <p class="policy-child-doc__p">
                    4、高途毛豆未经用户同意不向任何第三方公开、 透露用户个人隐私信息。但以下特定情形除外：(1) 高途毛豆根据法律法规规定或有权机关的指示提供用户的个人隐私信息；(2) 由于用户将其用户密码告知他人或与他人共享注册帐户与密码，由此导致的任何个人信息的泄漏，或其他非因高途毛豆原因导致的个人隐私信息的泄露；(3) 用户自行向第三方公开其个人隐私信息；(4) 用户与高途毛豆及合作单位之间就用户个人隐私信息的使用公开达成约定，高途毛豆因此向合作单位公开用户个人隐私信息；(5) 任何由于黑客攻击、电脑病毒侵入及其他不可抗力事件导致用户个人隐私信息的泄露。
                </p>
                <p class="policy-child-doc__p">
                    5、用户同意高途毛豆可在以下事项中使用用户的个人隐私信息：(1) 高途毛豆向用户及时发送重要通知，如软件更新、本协议条款的变更；(2)依本协议约定，高途毛豆管理、审查用户信息及进行处理措施；(3) 适用法律法规规定的其他事项。除上述事项外，如未取得用户事先同意，高途毛豆不会将用户个人隐私信息使用于任何其他用途。
                </p>
                <p class="policy-child-doc__p">
                    6、高途毛豆会不时更新本隐私权保护声明。我们会在毛豆系列应用软件和网站上发布对隐私权声明所做的变更内容。当您接受本协议条款时，您同样认可并接受毛豆系列应用隐私政策的条款。
                </p>
                <p class="policy-child-doc__p">
                    高途毛豆十分重视未成年人的隐私保护，若您是18周岁以下的未成年人，在使用毛豆系列应用的服务前，应事先取得您家长或法定监护人的书面同意。高途毛豆根据国家相关法律法规的规定保护未成年人的个人信息。
                </p>
            </section>
            <section class="policy-child-doc__section">
                <h2>五、知识产权</h2>
                <p class="policy-child-doc__p">
                    1、网站及软件使用
                </p>
                <p class="policy-child-doc__p">
                    用户下载安装毛豆系列应用软件并登录后方得以从客户端使用高途毛豆所提供的服务。高途毛豆在此授予用户免费的、不可转让的、非独占的全球性个人许可，允许用户使用由高途毛豆提供的、包含在服务中的软件。但是，用户不得复制、修改、发布、出售或出租高途毛豆的服务软件或所含软件的任何部分，也不得进行反向工程或试图提取该软件的源代码。
                </p>
                <p class="policy-child-doc__p">
                    2、版权
                </p>
                <p class="policy-child-doc__p">
                    毛豆系列应用以任何形式表现的作品包括但不限于网页文字、图片、音频、视频、软件等的知识产权均归高途毛豆所有或高途毛豆已取得合法授权，非经高途毛豆书面许可，用户非基于自我学习之目的外，不得以任何方式下载、录屏、复制、修改、转让、分发、出售或传输毛豆系列应用中的内容或创造相关衍生作品。
                </p>
                <p class="policy-child-doc__p">
                    3、企业标识及商标
                </p>
                <p class="policy-child-doc__p">
                    毛豆系列应用软件服务中所涉及的logo图形、文字或其组成，及产品、服务名称，均为高途毛豆之商标或企业标识。未经高途毛豆事先书面同意，用户不得将毛豆系列应用软件标识以任何方式展示或使用或作其他处理，也不得向他人表明您有权展示、使用、或其他有权处理毛豆系列应用软件标识的行为。
                </p>
            </section>
            <section class="policy-child-doc__section">
                <h2>六、用户注意义务特别提示</h2>
                <p class="policy-child-doc__p">
                    禁止用户上传毛豆系列应用软件的信息含有以下内容：
                </p>
                <p class="policy-child-doc__p">
                    （一）反对宪法确定的基本原则的；
                </p>
                <p class="policy-child-doc__p">
                    （二）危害国家统一、主权和领土完整的；
                </p>
                <p class="policy-child-doc__p">
                    （三）泄露国家秘密、危害国家安全或者损害国家荣誉和利益的；
                </p>
                <p class="policy-child-doc__p">
                    （四）煽动民族仇恨、民族歧视，破坏民族团结，或者侵害民族风俗、习惯的；
                </p>
                <p class="policy-child-doc__p">
                    （五）宣扬邪教、迷信的；
                </p>
                <p class="policy-child-doc__p">
                    （六）扰乱社会秩序，破坏社会稳定的；
                </p>
                <p class="policy-child-doc__p">
                    （七）诱导未成年人违法犯罪和渲染暴力、色情、赌博、恐怖活动的；
                </p>
                <p class="policy-child-doc__p">
                    （八）侮辱或者诽谤他人，侵害公民个人隐私等他人合法权益的；
                </p>
                <p class="policy-child-doc__p">
                    （九）危害社会公德，损害民族优秀文化传统的；
                </p>
                <p class="policy-child-doc__p">
                    （十）有关法律、行政法规和国家规定禁止的其他内容。
                </p>
                <p class="policy-child-doc__p">
                    如果用户不具备完全民事权利能力和完全民事行为能力的自然人，请务必在法定监护人陪同下审阅并遵守本协议，一旦注册即视为其监护人已明知并允许未成年人注册并使用毛豆系列应用软件服务。
                </p>
            </section>
            <section class="policy-child-doc__section">
                <h2>七、法律责任及免责</h2>
                <p class="policy-child-doc__p">
                    1、本《协议》遵守中华人民共和国相关的法律法规。如本《协议》中某些条款与中华人民共和国现行法律法规相抵触时，这些条款将完全按照现行法律规定重新解释，但不影响其它条款的有效性和本《协议》的整体效力。
                </p>
                <p class="policy-child-doc__p">
                    2、用户违反本《协议》或相关的服务条款的规定，导致或产生的任何第三方主张的任何索赔、要求或损失等，应由用户承担赔偿责任，由此给高途毛豆造成损失的，用户亦应对高途毛豆承担赔偿责任。
                </p>
                <p class="policy-child-doc__p">
                    3、由于用户将个人注册账号信息告知他人或与他人共享注册帐号，由此导致的任何风险或损失，由用户自行承担。
                </p>
                <p class="policy-child-doc__p">
                    4、用户因第三方如电信部门的通讯线路故障、技术问题、网络、电脑故障、系统不稳定性及其他各种不可抗力原因而遭受的一切损失，高途毛豆及合作单位不承担责任。
                </p>
                <p class="policy-child-doc__p">
                    5、因技术故障等不可抗事件影响到服务的正常运行的，高途毛豆承诺在第一时间内与相关单位配合，及时处理进行修复，但用户因此而遭受的一切损失，高途毛豆不承担责任。
                </p>
            </section>
            <section class="policy-child-doc__section">
                <h2>八、服务终止</h2>
                <p class="policy-child-doc__p">
                    用户在使用毛豆系列应用软件服务的过程中，具有下列情形时，高途毛豆有权采取封号等措施终止对该用户的服务：
                </p>
                <p class="policy-child-doc__p">
                    1、用户以非法目的使用毛豆系列应用软件服务；
                </p>
                <p class="policy-child-doc__p">
                    2、用户不以学习的真实交易为目的使用毛豆系列应用软件服务；
                </p>
                <p class="policy-child-doc__p">
                    3、用户存在多次被投诉等不良记录的；
                </p>
                <p class="policy-child-doc__p">
                    4、用户存在采用非法下载、录屏、出售等方式侵犯高途毛豆或其他第三方知识产权等合法权益的行为；
                </p>
                <p class="policy-child-doc__p">
                    5、用户存在严重违反本协议约定义务的行为；
                </p>
                <p class="policy-child-doc__p">
                    6、其他高途毛豆认为需要终止服务的情况。
                </p>
                <p class="policy-child-doc__p">
                    高途毛豆终止用户服务时，将以用户注册时预留的手机号码等联系方式通知用户。
                </p>
            </section>
            <section class="policy-child-doc__section">
                <h2>九、其他条款</h2>
                <p class="policy-child-doc__p">
                    1、本《协议》所定的任何条款的部分或全部无效者，不影响其它条款的效力。
                </p>
                <p class="policy-child-doc__p">
                    2、本《协议》的解释、效力及纠纷的解决，适用于中华人民共和国法律。若用户和高途毛豆之间发生任何纠纷或争议，首先应友好协商解决，协商不成的，用户在此完全同意将纠纷或争议提交高途毛豆住所地即北京市有管辖权的人民法院管辖。
                </p>
                <p class="policy-child-doc__p">
                    3、本《协议》的版权由高途毛豆所有，高途毛豆保留在法律许可范围内的解释和修改权利。
                </p>
            </section>
            <section class="policy-child-doc__section">
                <h2>十、如何联系我们</h2>
                <p class="policy-child-doc__p">
                    如您对本用户协议有任何疑问，或对于个人信息处理存在任何投诉、意见，请通过以下渠道联系我们，我们将在收到问题、意见或建议后的十五天内回复您的请求：
                </p>
                <p class="policy-child-doc__p">
                    高途教育科技集团有限公司-毛豆学部-毛豆项目组
                </p>
                <p class="policy-child-doc__p">
                    邮箱: xuelu@gaotu.cn
                </p>
                <p class="policy-child-doc__p">
                    电话: 4000910188
                </p>
                <p class="policy-child-doc__p">
                    邮寄地址：北京市海淀区中关村软件园文思海辉大厦-毛豆学部（收）
                </p>
                <p class="policy-child-doc__p">
                    应用内咨询：点击“毛豆系列应用软件”中的“客服中心”功能
                </p>
                <p class="policy-child-doc__p">
                    需注意的是，我们可能不会回复与用户协议和个人信息保护无关的问题。
                </p>
            </section>
        </div>
    </div>
</template>

<script>

export default {
    name: 'PolicyProtocolPage',
    components: {
    },
    mounted() {
        document.title = '用户服务协议';
    },
};
</script>

<style src="../child/policyChildDoc.css"></style>

<style scoped>
.policy-protocol-page {
    min-height: 100vh;
    background: #fff;
}
</style>
